// extracted by mini-css-extract-plugin
export var actuItem = "listActus-module--actu-item--4d82d";
export var actuItemsContainer = "listActus-module--actu-items-container--839e4";
export var actualiteCategorie = "listActus-module--actualite-categorie--32246";
export var actualiteDate = "listActus-module--actualite-date--a957e";
export var actualiteInfos = "listActus-module--actualite-infos--484e2";
export var actualiteResume = "listActus-module--actualite-resume--4ef6b";
export var actualiteTitle = "listActus-module--actualite-title--de5b7";
export var actusFilters = "listActus-module--actus-filters--449c0";
export var listActualitesContainer = "listActus-module--list-actualites-container--8701c";
export var listActus = "listActus-module--list-actus--536e0";
export var vocalizedUpdate = "listActus-module--vocalized-update--7f6f3";
export var zoneActualitesLibreBas = "listActus-module--zone-actualites-libre-bas--8a806";
export var zoneActualitesLibreHaut = "listActus-module--zone-actualites-libre-haut--b4ca9";